<template>
  <div
    class="page_container myHeader_wrap default_font"
    @click="menu_show = false"
    :style="{ background: isDark ? '#24272a' : '#f0f1fa' }"
    :class="{ scrolled: isScrolled, fixedMenu: isScrolled }"
  >
    <div class="logo" @click="goIndex('/')">
      <img
        v-if="!isDark"
        src="https://download.hecoos.com/enlightv/2025-17/b2213288ba82eec36605091e0f57740c.png"
        alt=""
        srcset=""
      />
      <img
        v-else
        src="https://download.hecoos.com/enlightv/2025-17/9afd9fdb8b5717b4b118b43b3c449e13.png"
        alt=""
        srcset=""
      />
    </div>
    <div class="myHeader_content">
      <div @click="goLogin" class="userImg">
        <img
          src="https://download.hecoos.com/enlightv/2025-17/bd72ab1a61c3f8ed601832eabb926da3.png"
          alt=""
          srcset=""
        />
      </div>
      <!-- 语言切换按钮 -->
      <div class="language" @click="changeLanguage">
        {{ languageText }}&nbsp;&nbsp;<span></span>
      </div>

      <div class="hecoos_menu" :class="{ active: menu_show }" @click.stop>
        <div class="hecoos_menu_btn" @click.stop="handleClickMenu">
          菜单<span :class="{ 'rotate-90': menu_show }">
            <i></i>
            <i></i>
          </span>
        </div>
        <div class="hecoos_menu_wrap">
          <ul>
            <template v-for="(list, index) in menu">
              <li v-if="list.name != '关于我们'">
                <div class="hecoos_menu_link">
                  <!-- 修改此处 -->
                  <a
                    v-if="list.name === '艺书学习平台'"
                    :href="list.url"
                    target="_blank"
                  >
                    <span class="header-menu-link-text">{{ list.name }}</span>
                    <span class="header-menu-link-text-clone">{{
                      list.name
                    }}</span>
                  </a>
                  <!--  -->
                  <router-link
                    v-else
                    class="menu_item"
                    :to="list.url ? list.url : $route.path"
                  >
                    <span class="header-menu-link-text">{{ list.name }}</span>
                    <span class="header-menu-link-text-clone">{{
                      list.name
                    }}</span>
                  </router-link>
                  <span
                    class="radio radio_span"
                    v-if="list.url && $route.path === list.url"
                  ></span>
                  <span
                    class="radio iconfont icon-xiangxiajiantou"
                    v-if="list.item && list.item.length > 0"
                  ></span>
                </div>

                <div
                  class="hecoos_menu_child"
                  v-if="list.item && list.item.length"
                >
                  <ul>
                    <li v-for="(child, index) in list.item" :key="index">
                      <div class="hecoos_menu_link">
                        <a
                          v-if="child.name === '艺书学习平台'"
                          :href="child.url"
                          target="_blank"
                        >
                          <span class="header-menu-link-text">{{
                            child.name
                          }}</span>
                          <span class="header-menu-link-text-clone">{{
                            child.name
                          }}</span>
                        </a>
                        <router-link
                          v-else
                          class="menu_item"
                          :to="{ path: child.url ? child.url : $route.path }"
                        >
                          <span class="header-menu-link-text">{{
                            child.name
                          }}</span>
                          <span class="header-menu-link-text-clone">{{
                            child.name
                          }}</span>
                        </router-link>
                        <span
                          class="radio radio_span"
                          v-if="child.url && $route.path === child.url"
                        ></span>
                        <span
                          class="radio iconfont icon-xiangxiajiantou"
                          v-if="child.item && child.item.length > 0"
                        ></span>
                      </div>

                      <div
                        class="hecoos_menu_child"
                        v-if="child.item && child.item.length"
                      >
                        <ul>
                          <li
                            v-for="(grandson, index) in child.item"
                            :key="index"
                          >
                            <div class="hecoos_menu_link">
                              <a
                                v-if="grandson.name === '艺书学习平台'"
                                :href="grandson.url"
                                target="_blank"
                              >
                                <span class="header-menu-link-text">{{
                                  grandson.name
                                }}</span>
                                <span class="header-menu-link-text-clone">{{
                                  grandson.name
                                }}</span>
                              </a>
                              <!-- grandson.url ? grandson.url : $route.path -->
                              <router-link
                                v-else
                                class="menu_item"
                                :to="{
                                  hash: child.name == 'server' ? '#tab' : '',
                                  path: grandson.url
                                    ? grandson.url
                                    : $route.path,
                                }"
                              >
                                <span class="header-menu-link-text">{{
                                  grandson.name
                                }}</span>
                                <span class="header-menu-link-text-clone">{{
                                  grandson.name
                                }}</span>
                              </router-link>
                              <span
                                class="radio radio_span"
                                v-if="
                                  grandson.url && $route.path === grandson.url
                                "
                              ></span>
                              <span
                                class="radio iconfont icon-xiangxiajiantou"
                                v-if="grandson.item && grandson.item.length > 0"
                              ></span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li v-else>
                <div class="hecoos_menu_link">
                  <router-link
                    class="menu_item"
                    :to="list.url ? list.url : $route.path"
                    style="font-family: '黑体'; font-weight: bold"
                  >
                    <span class="header-menu-link-text">{{ list.name }}</span>
                    <span class="header-menu-link-text-clone">{{
                      list.name
                    }}</span>
                  </router-link>
                  <span
                    class="radio radio_span"
                    v-if="list.url && $route.path === list.url"
                  ></span>
                  <span
                    class="radio iconfont icon-xiangxiajiantou"
                    v-if="list.item && list.item.length > 0"
                  ></span>
                </div>

                <div
                  class="hecoos_menu_child"
                  v-if="list.item && list.item.length"
                >
                  <ul>
                    <li v-for="(child, index) in list.item" :key="index">
                      <div class="hecoos_menu_link">
                        <router-link
                          class="menu_item"
                          :to="{ path: child.url ? child.url : $route.path }"
                        >
                          <span class="header-menu-link-text">{{
                            child.name
                          }}</span>
                          <span class="header-menu-link-text-clone">{{
                            child.name
                          }}</span>
                        </router-link>
                        <span
                          class="radio radio_span"
                          v-if="child.url && $route.path === child.url"
                        ></span>
                        <span
                          class="radio iconfont icon-xiangxiajiantou"
                          v-if="child.item && child.item.length > 0"
                        ></span>
                      </div>

                      <div
                        class="hecoos_menu_child"
                        v-if="child.item && child.item.length"
                      >
                        <ul>
                          <li
                            v-for="(grandson, index) in child.item"
                            :key="index"
                          >
                            <div class="hecoos_menu_link">
                              <a
                                v-if="grandson.name === '艺书学习平台'"
                                :href="grandson.url"
                                target="_blank"
                              >
                                <span class="header-menu-link-text">{{
                                  grandson.name
                                }}</span>
                                <span class="header-menu-link-text-clone">{{
                                  grandson.name
                                }}</span>
                              </a>
                              <!-- grandson.url ? grandson.url : $route.path -->
                              <router-link
                                v-else
                                class="menu_item"
                                :to="{
                                  hash: child.name == 'server' ? '#tab' : '',
                                  path: grandson.url
                                    ? grandson.url
                                    : $route.path,
                                }"
                              >
                                <span class="header-menu-link-text">{{
                                  grandson.name
                                }}</span>
                                <span class="header-menu-link-text-clone">{{
                                  grandson.name
                                }}</span>
                              </router-link>
                              <span
                                class="radio radio_span"
                                v-if="
                                  grandson.url && $route.path === grandson.url
                                "
                              ></span>
                              <span
                                class="radio iconfont icon-xiangxiajiantou"
                                v-if="grandson.item && grandson.item.length > 0"
                              ></span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuVisible: false,
      isMenuVisible1: false,
      menuHideTimer: null,
      test: [], // 初始化为空数组
      menu: [
        {
          name: "首页",
          url: "/",
        },
        {
          name: "解决方案",
          item: [
            {
              name: "投影映射",
              url: "/projection",
            },
            {
              name: "灯光",
              url: "/lightingDesign",
            },
            {
              name: "虚拟制作xR/VP",
              url: "/virtualProduction",
            },
            {
              name: "实时渲染与交互",
              url: "/renderInteraction",
            },
          ],
        },
        {
          name: "产品",
          item: [
            {
              name: "hecoos Studio",
              url: "/studio",
            },
            {
              name: "hecoos Lighting",
              url: "/hecoosLighting",
            },
            {
              name: "hecoos Server",
              url: "/mediaServer",
              item: [
                {
                  name: "Server-D",
                  url: "/mediaServer?section=0",
                },
                {
                  name: "Server-C",
                  url: "/mediaServer?section=1",
                },
                {
                  name: "Server-R",
                  url: "/mediaServer?section=2",
                },
              ],
            },

            {
              name: "其他产品",
              item: [
                {
                  name: "Mirror",
                  url: "/projectorbit",
                },
              ],
            },
          ],
        },
        {
          name: "学习",
          item: [
            {
              name: "hecoos视频教程",
              url: "/video_tutorial",
            },
            {
              name: "高校专业共建",
              url: "/construction",
            },
            {
              name: "艺书学习平台",
              url: "https://www.artbook.top",
            },
          ],
        },
        {
          name: "开通会员",
          url: "/SoftwareSubscriptions",
        },
        {
          name: "案例展示",
          url: "/casepresentation",
        },
        {
          name: "关于我们",
          url: "/CaseDemonstration",
        },
      ],
      currentHoverIndex: -1, // 记录当前悬停的主菜单项索引
      currentSubHoverIndex: -1, // 记录当前悬停的第二层菜单项索引
      controlSpot: false,
      menu_show: false,
      isScrolled: false,
    };
  },
  props: {
    isDark: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 150;
    },
    goIndex(path) {
      this.$router.push(path);
    },
    handleClickMenu() {
      this.menu_show = !this.menu_show;
      // this.controlSpot = !this.controlSpot;
    },
    goLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push("/personalCenter");
      } else {
        this.$router.push("/login");
      }
    },
    // changeLanguage() {
    //   const currentRoute = this.$route.path;
    //   const targetPrefix = this.$route.meta.language === "ch" ? "/en" : "";
    //   let targetRoute;
    //   if (currentRoute.startsWith("") || currentRoute.startsWith("/en")) {
    //     const regex = new RegExp(`^/${currentRoute.split("/")[1]}`);
    //     targetRoute = currentRoute.replace(regex, targetPrefix);
    //   } else {
    //     targetRoute = targetPrefix + "/home";
    //   }
    //   if (targetRoute !== currentRoute) {
    //     this.$router.push(targetRoute).then(() => {
    //       // 路由跳转成功后，强制更新组件，确保语言文本正确显示
    //       this.$forceUpdate();
    //     });
    //   }
    // },
    changeLanguage() {
      const currentRoute = this.$route.path;
      const isEnglish = this.$route.meta.language === "en"; // 判断当前是否是英文

      let targetRoute;

      if (isEnglish) {
        // 当前是英文，切换到中文（去掉/en前缀）
        if (currentRoute.startsWith("/en")) {
          targetRoute = currentRoute.replace(/^\/en/, "");
          // 处理根路径情况
          if (targetRoute === "") targetRoute = "/";
        } else {
          targetRoute = "/";
        }
      } else {
        // 当前是中文，切换到英文（添加/en前缀）
        if (currentRoute === "/") {
          targetRoute = "/en";
        } else {
          targetRoute = "/en" + currentRoute;
        }
      }

      if (targetRoute !== currentRoute) {
        this.$router.push(targetRoute).then(() => {
          this.$forceUpdate();
        });
      }
    },
    showMenu() {
      this.clearMenuTimer();
      this.isMenuVisible = true;
      this.controlSpot = true;
    },
    hideMenu() {
      this.menuHideTimer = setTimeout(() => {
        this.controlSpot = false;
        this.isMenuVisible = false;
        this.isMenuVisible1 = false;
        this.currentHoverIndex = -1;
        this.currentSubHoverIndex = -1; // 隐藏主菜单时重置第二层菜单悬停索引
      }, 100);
    },
    showMenu1(msg, index) {
      if (msg.url && this.$route.path === msg.url) {
        return;
      }
      this.clearMenuTimer();
      if (
        this.currentHoverIndex !== -1 &&
        this.menu[this.currentHoverIndex].item
      ) {
        this.isMenuVisible1 = false;
      }
      this.currentHoverIndex = index;
      if (msg.item) {
        if (this.test !== msg.item) {
          this.test = msg.item;
        }
        this.isMenuVisible1 = true;
      }
    },
    hideMenu1() {
      this.menuHideTimer = setTimeout(() => {
        this.isMenuVisible1 = false;
        this.currentHoverIndex = -1;
        this.currentSubHoverIndex = -1; // 隐藏子菜单时重置第二层菜单悬停索引
      }, 100);
    },
    showSubMenu1(index) {
      this.clearMenuTimer();
      this.currentSubHoverIndex = index;
    },
    hideSubMenu1() {
      this.menuHideTimer = setTimeout(() => {
        this.currentSubHoverIndex = -1;
      }, 100);
    },
    keepMenu1Visible() {
      this.clearMenuTimer();
    },
    clearMenuTimer() {
      if (this.menuHideTimer) {
        clearTimeout(this.menuHideTimer);
        this.menuHideTimer = null;
      }
    },
  },
  computed: {
    languageText() {
      return this.$route.meta.language === "ch" ? "EN" : "CH";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/xty.scss";

@font-face {
  font-family: "iconfont";
  /* Project id 4847554 */
  src: url("//at.alicdn.com/t/c/font_4847554_50o1jolhtim.woff2?t=1741167400416")
      format("woff2"),
    url("//at.alicdn.com/t/c/font_4847554_50o1jolhtim.woff?t=1741167400416")
      format("woff"),
    url("//at.alicdn.com/t/c/font_4847554_50o1jolhtim.ttf?t=1741167400416")
      format("truetype");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-xiangxiajiantou:before {
  content: "\e651";
}

.page_container.myHeader_wrap {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 152px;
  opacity: 1;
  transition: all 1s ease;
  &.scrolled {
    background-color: transparent !important;
    padding-bottom: 0;
    justify-content: end;
    .logo {
      display: none;
    }
  }
}

.myHeader_box {
  padding: 50px 120px;
  height: 152px;
  div {
    height: 52px;
  }
}
.page_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f0f1fa;
  // background-color: rgb(68, 51, 51);
  padding: 50px 120px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 998; /* 确保导航栏在其他内容上方 */
  transition: all 0.3s ease; /* 可选：添加过渡效果 */
  .myHeader_content {
    animation: fadeOut 1s forwards;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 0; /* 动画开始时（0%进度）的状态 */
  }
  100% {
    opacity: 1; /* 动画结束时（100%进度）的状态 */
  }
}
.page_container.fixedMenu {
  padding-top: 0px;
  .myHeader_content {
    position: fixed;
    top: 50px;
    right: 120px;
    opacity: 1;
    animation: fadeIn 1s forwards;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0; /* 动画开始时（0%进度）的状态 */
  }
  100% {
    opacity: 1; /* 动画结束时（100%进度）的状态 */
  }
}
.menu-item-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.menu span {
  transition: all 0.3s ease;
}

.rotate-90 {
  display: inline-block;
  transform: rotate(90deg);
}

.hecoos_menu {
  width: 146px;
  height: 52px;
  position: relative;

  &.active {
    .hecoos_menu_wrap {
      pointer-events: auto;
      display: block;
      transform: translateZ(0);
      opacity: 1;
    }
  }

  .hecoos_menu_btn {
    background-color: #e4e6ef;
    width: 146px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    color: #000;
    border-radius: 26px;
    font-size: 24px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      margin-left: 16px;
      font-size: 38px;
      display: flex;
      justify-content: center;

      i {
        width: 8px;
        height: 8px;
        background: #000;
        display: block;
        border-radius: 50%;
        margin-left: 5px;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    &:hover {
      background: #fff;
    }
  }

  .hecoos_menu_wrap {
    position: absolute;
    width: max-content;
    top: 68px;
    right: 0;
    border-radius: 18px;
    background: rgba(255, 255, 255, 1);
    overflow: initial;
    opacity: 0;
    z-index: 100;
    pointer-events: none;
    transition: transform 0.5s var(--open-delay) cubic-bezier(0.4, 0, 0.1, 1),
      opacity 0.5s var(--open-delay) cubic-bezier(0.4, 0, 0.1, 1),
      z-index 0s var(--open-delay);
    transform: translate3d(0, 5.5em, 0) rotate(3.5deg);

    ul {
      min-width: 370px;
      padding: 30px 0;
      box-sizing: border-box;

      li {
        width: 100%;
        margin-bottom: 0px;
        padding: 0 15px;
        height: 62px;

        .hecoos_menu_link {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 62px;
          padding: 15px 20px;
          box-sizing: border-box;
          transition: 0.3s opacity, 0.4s transform cubic-bezier(0.4, 0, 0.1, 1);
          transform: scale(0.9);

          a {
            width: 100%;
            display: block;
            height: 32px;
            line-height: 32px;
            text-align: left;
            color: black;
            text-decoration: none;
            font-size: 24px;
            position: relative;
            overflow: hidden;

            .header-menu-link-text {
              display: inline-block;
              position: relative;
              transition: 0.4s color,
                0.4s transform cubic-bezier(0.4, 0, 0.1, 1);
              z-index: 1;
            }

            .header-menu-link-text-clone {
              position: absolute;
              transition: 0.4s color,
                0.4s transform cubic-bezier(0.4, 0, 0.1, 1);
              z-index: 1;
              top: 0;
              left: 0;
              transform: translate3d(0, 100%, 0);
            }
          }

          span.radio {
            font-size: 26px;

            &.radio_span {
              width: 8px;
              height: 8px;
              background: #000;
              display: block;
              border-radius: 50%;
            }

            &.icon-xiangxiajiantou {
              opacity: 0;
              transition: 0.3s opacity,
                0.4s transform cubic-bezier(0.4, 0, 0.1, 1);
            }
          }
        }

        /* 第一级菜单项悬停效果 */
        &:hover {
          > .hecoos_menu_link {
            transform: scale(1);
            background: rgba(230, 235, 252, 1);

            a {
              .header-menu-link-text-clone {
                transform: translateZ(0);
              }

              .header-menu-link-text {
                transform: translate3d(0, -100%, 0);
              }
            }

            span.icon-xiangxiajiantou {
              opacity: 1;
            }
          }

          .hecoos_menu_child {
            opacity: 1;
            transform: scale(1);
            pointer-events: auto;
          }
        }

        .hecoos_menu_child {
          width: 100%;
          position: absolute;
          left: -370px;
          top: 0;
          opacity: 0;
          transform: scale(0.9);
          transform-origin: top right;
          display: block;
          height: 100%;
          background: rgba(255, 255, 255, 1);
          border-radius: 18px;
          pointer-events: none;
          transition: opacity 0.3s ease, transform 0.3s ease;

          &:after {
            width: 30px;
            height: 100%;
            background: #fff;
            position: absolute;
            right: -15px;
            content: " ";
            top: 0px;
          }

          &:before {
            width: 1px;
            height: calc(100% - 60px);
            background: rgba(166, 166, 166, 1);
            position: absolute;
            right: 0;
            content: " ";
            top: 30px;
          }

          ul li {
            /* 第二级菜单项悬停效果 */
            &:hover {
              > .hecoos_menu_link {
                transform: scale(1);
                background: rgba(230, 235, 252, 1);

                a {
                  .header-menu-link-text-clone {
                    transform: translateZ(0);
                  }

                  .header-menu-link-text {
                    transform: translate3d(0, -100%, 0);
                  }
                }

                span.icon-xiangxiajiantou {
                  opacity: 1;
                }
              }

              .hecoos_menu_child {
                opacity: 1;
                transform: scale(1);
                pointer-events: auto;
              }
            }

            .hecoos_menu_child {
              width: 100%;
              position: absolute;
              left: -370px;
              top: 0;
              opacity: 0;
              transform: scale(0.9);
              transform-origin: top right;
              display: block;
              height: 100%;
              background: rgba(255, 255, 255, 1);
              border-radius: 18px;
              pointer-events: none;
              transition: opacity 0.3s ease, transform 0.3s ease;

              &:before {
                width: 1px;
                height: calc(100% - 60px);
                background: rgba(166, 166, 166, 1);
                position: absolute;
                right: 0;
                content: " ";
                top: 30px;
              }

              ul li {
                /* 第三级菜单项悬停效果 */
                &:hover .hecoos_menu_link {
                  transform: scale(1);
                  background: rgba(230, 235, 252, 1);

                  a {
                    .header-menu-link-text-clone {
                      transform: translateZ(0);
                    }

                    .header-menu-link-text {
                      transform: translate3d(0, -100%, 0);
                    }
                  }

                  span.icon-xiangxiajiantou {
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .hecoos_menu .hecoos_menu_wrap ul {
    padding: 12px 0;
    li {
      height: 52px;
      .hecoos_menu_link {
        padding: 10px 20px;
      }
    }
  }
}
</style>
